import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=1d232c77&"
import script from "./empty-layout.vue?vue&type=script&lang=ts&"
export * from "./empty-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d232c77')) {
      api.createRecord('1d232c77', component.options)
    } else {
      api.reload('1d232c77', component.options)
    }
    module.hot.accept("./empty-layout.vue?vue&type=template&id=1d232c77&", function () {
      api.rerender('1d232c77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layouts/empty-layout.vue"
export default component.exports